import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getSidebarItems, filterByHiddenItemsId, clearFilters } from "../../actions/sidebarActions";
import DropDownSidebarItems from "./Components/DropDownSidebarItems";
import SidebarItem from "./Components/SidebarItem";
import $ from 'jquery';

const SideBar = ({ idUser, idSeller, userType, hiddenItemsId, clearFilters }) => {
    const [sidebarItems, setSidebarItems] = useState([]);

    useEffect(() => {
        $(window).ready(setClassMiniSidebar);
        $(window).on("resize", setClassMiniSidebar);
    }, []);

    useEffect(() => {
        const sidebarItemsByUser = getSidebarItems(userType, idSeller, idUser);

        if (userType?.isProveedor) {
            setSidebarItems(sidebarItemsByUser);
        } else if (hiddenItemsId?.length > 0) {
            setSidebarItems(filterByHiddenItemsId(sidebarItemsByUser, hiddenItemsId));
        } else {
            setSidebarItems(sidebarItemsByUser);
        }
    }, [hiddenItemsId, userType, idSeller, idUser]);

    const setClassMiniSidebar = () => {
        var topOffset = 0;
        var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;

        if (width < 1170) {
            $("body").addClass("mini-sidebar");
            $('.navbar-brand span').hide();
            $(".sidebartoggler i").addClass("ti-menu");
        } else {
            $("body").removeClass("mini-sidebar");
            $('.navbar-brand span').show();
        }

        var height = (window.innerHeight > 0 ? window.innerHeight : this.screen.height) - 1;
        height = height - topOffset;
        if (height < 1) height = 1;
        if (height > topOffset) {
            $(".page-wrapper").css("min-height", (height) + "px");
        }
    };

    const renderSidebarItems = (item, isChildItem) => {
        if (item.childItems) {
            return (
                <DropDownSidebarItems key={item.id} {...item}>
                    {item.childItems.map((childItem) => renderSidebarItems(childItem, true))}
                </DropDownSidebarItems>
            )
        } else {
            return (
                <SidebarItem
                    key={item.id}
                    isChild={isChildItem}
                    clearFilters={onClearFilters}
                    {...item}
                />
            )
        }
    }

    const onClearFilters = () => {
        clearFilters(userType, idSeller);
    }

    return (
        <aside className="left-sidebar">
            <div className="scroll-sidebar background-gris-megatone">
                <nav className="sidebar-nav background-gris-megatone">
                    <ul id="sidebarnav" className="text-start animated fadeInLeft">
                        {sidebarItems.map((item) => { return renderSidebarItems(item) })}
                        <li className='p-3' />
                    </ul>
                </nav>
            </div>
        </aside>
    );
}

const mapStateToProps = state => ({
    idUser: state.general.userId,
    idSeller: state.general.idSeller,
    userType: state.general.userType,
    hiddenItemsId: state.sidebar.hiddenItemsId,
})

const mapDispatchToProps = {
    clearFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);